<template>
  <Section
    :id="id"
    :header="t('orders.notesComments')"
    class="note-section"
    data-class="flex flex-column flex-gap-1"
  >
    <PopupTextArea
      :id="`${id}-internal-notes`"
      :model-value="internalNotes"
      :label="t('orders.paramNotes', { param: t('orders.internal') })"
      :disabled="!editable"
      @update:model-value="emit('update:internal-notes', $event)"
    />
    <PopupTextArea
      :id="`${id}-carrier-notes`"
      :model-value="carrierNotes"
      :label="t('orders.paramNotes', { param: t('carriers.carriers') })"
      :disabled="!editable"
      @update:model-value="emit('update:carrier-notes', $event)"
    />
  </Section>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import PopupTextArea from '@rygen/rygen-ui/components/popup/PopupTextarea.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  internalNotes: {
    type: String,
    required: false,
    default: () => '',
  },
  carrierNotes: {
    type: String,
    required: false,
    default: () => '',
  },
  editable: {
    type: Boolean,
    default: () => false,
  },
});
const { id, internalNotes, carrierNotes, editable } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:internal-notes', newVal: string): void;
  (event: 'update:carrier-notes', newVal: string): void;
}>();

const { t } = useI18n();
</script>

<style>
.note-section {
  .popup-textarea {
    .popup-inputgroup-card {
      width: calc(100% + 32px);
    }
  }
}
</style>
